var map = {
	"./1.png": "Txl5",
	"./222.png": "XboF",
	"./Contact-info.png": "jGXK",
	"./Contact.png": "QCTk",
	"./Testimonial.png": "bGw/",
	"./Testimonial1.png": "XiGS",
	"./Testimonial2.png": "tH18",
	"./about-bg.png": "j313",
	"./aboutus.png": "6uiW",
	"./appstore.png": "Rf8H",
	"./auth-bg.png": "d7Qf",
	"./back.png": "DtD7",
	"./browsers/chrome.png": "iB4l",
	"./browsers/firefox.png": "yOtu",
	"./browsers/ie.png": "uqIx",
	"./browsers/opera.png": "xqxY",
	"./browsers/safari.png": "OAVQ",
	"./circle-1.png": "7XRM",
	"./circle-2.png": "vNPd",
	"./circle-3.png": "26UE",
	"./color/color-2/1.png": "07YU",
	"./color/color-2/Homev1.png": "1RwD",
	"./color/color-2/Homev2.png": "GeOB",
	"./color/color-2/Homev3.png": "f/Y6",
	"./color/color-2/Testimonial.png": "iV9z",
	"./color/color-2/about-bg.png": "F0os",
	"./color/color-2/contact.png": "0rda",
	"./color/color-2/feature-bg1.png": "dcWM",
	"./color/color-2/price-bg.png": "x+rf",
	"./color/color-2/price.png": "RMD0",
	"./color/color-2/screenshot-bg.png": "M8Po",
	"./color/color-2/team-bg.png": "DF6a",
	"./color/color-2/team-img-bg.png": "A/Yg",
	"./color/color-3/1.png": "n2Jb",
	"./color/color-3/Homev2.png": "yAkE",
	"./color/color-3/Homev3.png": "5ewK",
	"./color/color-3/Testimonial.png": "fkqU",
	"./color/color-3/about-bg.png": "2u8l",
	"./color/color-3/contact.png": "PUbw",
	"./color/color-3/feature-bg1.png": "mhk0",
	"./color/color-3/price-bg.png": "a1w3",
	"./color/color-3/price.png": "emvA",
	"./color/color-3/screenshot-bg.png": "6iEg",
	"./color/color-3/team-bg.png": "ksU0",
	"./color/color-3/team-img-bg.png": "SJqP",
	"./color/color-3/testimonial-bg.png": "Y3RR",
	"./customer.png": "vv2t",
	"./demo/404.png": "tws9",
	"./demo/coming-soon.png": "MnSi",
	"./demo/download.png": "/POV",
	"./demo/email.png": "h78I",
	"./demo/faq.png": "AXP+",
	"./demo/forget-pwd.png": "06Ea",
	"./demo/review.png": "B7aC",
	"./demo/sign-in.png": "b5fc",
	"./demo/sign-up.png": "teDP",
	"./demo/thank-you.png": "6akV",
	"./down.png": "rix4",
	"./driver.png": "1S1t",
	"./driving.png": "MnMS",
	"./email.png": "vCvB",
	"./email/facebook-email.png": "8Lla",
	"./email/feed.png": "I5gV",
	"./email/google.png": "oUd3",
	"./email/instagram-email.png": "gJwI",
	"./email/twitter-email.png": "tKhp",
	"./en.png": "hRk0",
	"./error/cloud-bg-1.png": "CQE+",
	"./error/cloud-bg-2 - Copy.png": "M8Pn",
	"./error/cloud-bg-2.png": "q/eM",
	"./error/sad.png": "a2bI",
	"./favicon.png": "1H3f",
	"./fax.png": "vBzX",
	"./feature-bg.png": "Xhqm",
	"./feature-circle-two.png": "KZrA",
	"./feature-circle.png": "mkW3",
	"./feature2.png": "fnNz",
	"./features/all-broweser-support.png": "cvPG",
	"./features/animate-css.png": "dDoi",
	"./features/bootstrap-4.png": "5slL",
	"./features/color-management.png": "MnNr",
	"./features/css-3.png": "dBHD",
	"./features/fullpage-js.png": "kppf",
	"./features/google-fonts-support.png": "Y2nW",
	"./features/google-map.png": "UT53",
	"./features/html5.png": "CRM7",
	"./features/multiple-blog-layouts.png": "Dy2W",
	"./features/pixel-perfect-design.png": "w5QQ",
	"./features/responsive.png": "ZQ0r",
	"./features/social-links.png": "tB4H",
	"./features/three-type-home-page.png": "Qds5",
	"./features/typography.png": "jGQG",
	"./features/vue.png": "8NSn",
	"./features/w3c-validation.png": "XMwm",
	"./fotter-email.png": "phIc",
	"./home2/home2-slider.png": "s6ax",
	"./home2/logo-icon.png": "rmmc",
	"./home2/logo.png": "ZVat",
	"./home2/play-button.png": "BZ8Q",
	"./home2/slider-caption.png": "IXWz",
	"./home3/home-3-img.png": "QXWg",
	"./home3/home3-slider.png": "4gOx",
	"./icon/1.png": "nYED",
	"./icon/2.png": "XaML",
	"./icon/3.png": "k0u4",
	"./icon/4.png": "AOVd",
	"./icon/5.png": "2d/n",
	"./icon/6.png": "xchJ",
	"./icon1.png": "d0yY",
	"./icon2.png": "ceFa",
	"./icon3.png": "akCb",
	"./icon4.png": "72gb",
	"./instagram.png": "JGRZ",
	"./landing-logo.png": "VZdp",
	"./landing/1.png": "93zg",
	"./landing/2.png": "Zuxj",
	"./landing/3.png": "6PZE",
	"./landing/template.png": "FeVF",
	"./lannd-bg.png": "DKzj",
	"./light-right.png": "cDCj",
	"./light.png": "77ig",
	"./locate.png": "I7T+",
	"./logo.png": "iQH9",
	"./logoimage.png": "rEiP",
	"./mac.png": "WMFF",
	"./main-banner1.png": "zeIt",
	"./main-banner12.png": "+gyt",
	"./main-banner3.png": "jS8J",
	"./message.png": "Sbtz",
	"./mobile.png": "HXsc",
	"./next.png": "3aVt",
	"./phone.png": "JhOT",
	"./placeholder.png": "JVyh",
	"./play-store.png": "6hIX",
	"./price-bg.png": "pR8Y",
	"./price.png": "bt7z",
	"./rental.png": "RleS",
	"./screen1.png": "rkxw",
	"./screenshot-bg.png": "8bdc",
	"./screenshot-mob.png": "AkL+",
	"./screenshot/0.png": "ICv5",
	"./screenshot/1.png": "vDBw",
	"./screenshot/10.png": "jGJH",
	"./screenshot/11.png": "oNfB",
	"./screenshot/2.png": "0wGf",
	"./screenshot/3.png": "7DQw",
	"./screenshot/4.png": "xPQ0",
	"./screenshot/5.png": "UM8i",
	"./screenshot/6.png": "VZ2T",
	"./screenshot/7.png": "4luK",
	"./screenshot/8.png": "XiyF",
	"./screenshot/9.png": "rLZ4",
	"./star.png": "FHDy",
	"./team-bg.png": "nW+u",
	"./team-img-bg.png": "ZRVw",
	"./team.png": "QyPm",
	"./team1.png": "wu6y",
	"./team3.png": "1na9",
	"./telephone.png": "W8/8",
	"./testimonial-bg.png": "piVB",
	"./th.png": "w2gb",
	"./thank-you.png": "191p",
	"./website-logo.png": "pw1d",
	"./why.png": "faW0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 0